import { __require as r } from "../Request.mjs";
import { __require as e } from "../Errors.mjs";
import { __require as t } from "./buildInputData.mjs";
var n, o;
function u() {
  if (o) return n;
  o = 1;
  const u = r(),
    a = e(),
    s = t();
  return n = (r, e, t, n) => {
    if (r.isEmpty()) throw new a.BatchEmptyError();
    let o = new u();
    return 1 === r.length() ? o.parameters = i(r)[0] : o.payload = i(r), new Promise((n, u) => {
      e.send(o).then(e => {
        e.error && u(e.error), n(function (r, e) {
          return e.payload.map(e => {
            let n = new t(e);
            r.getByIndex(n.inputIndex).result.push(n);
          }), r;
        }(r, e));
      }).catch(u);
    });
    function i(r) {
      return r.lookups.map(r => s(r, n));
    }
  };
}
export { u as __require };